import { Injectable, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment.prod';

@Injectable()
export class GlobalService {

  constructor(
    private http: HttpClient,
    private toastr: ToastsManager,
    private translate: TranslateService,
    private router: Router) {
  }

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  public getVersion() {
    return environment.appVersion;
  }

  getToken() {
    return localStorage.getItem('key');
  }

  getBearerToken() {
    return localStorage.getItem('Bearer');
  }

  public urlContaE() {
    return document.getElementsByTagName('base')[0].href;
  }

  public verifyResponse(response) {
    
    if (response.Result != undefined) {

      if (response.Result) {
        return true;
      } else {
        if (response.Codigo === 0) {
          this.redirectWeb();
        }
        else if (response.Codigo < 0) {

          if (response.Codigo === -1 || response.Codigo === -2) {
            this.toastr.error(response.Message, 'Error!', { toastLife: 10000, showCloseButton: true });
          } else {
            this.translate.get('ERROR.' + response.Message).subscribe((res: string) => {
              this.toastr.error(res, 'Error!', { toastLife: 10000, showCloseButton: true });
            });
          }
          return false;
        } else {
          return true;
        }
      }
    }

    if (response.result != undefined) {

      if (response.result) {
        return true;
      } else {

        if (response.code == -90 || response.code == -91 || response.code == 0) {
          this.redirectWeb();
        }
      }
    }

    return true;
  }

  public verifyResponseJson(response) {
    
    if (response.result != undefined) {

      if (response.result) {
        return true;
      } else {
        if (response.code === 0) {
          this.redirectWeb();
        }
        else if (response.code < 0) {

          if (response.code === -1 || response.code === -2) {
            this.toastr.error(response.message, 'Error!', { toastLife: 10000, showCloseButton: true });
          } else {
            this.translate.get('ERROR.' + response.message).subscribe((res: string) => {
              this.toastr.error(res, 'Error!', { toastLife: 10000, showCloseButton: true });
            });
          }
          return false;
        } else {
          return true;
        }
      }
    }

    if (response.result != undefined) {

      if (response.result) {
        return true;
      } else {

        if (response.code == -90 || response.code == -91 || response.code == 0) {
          this.redirectWeb();
        }
      }
    }

    return true;
  }

  private redirectWeb() {
    this.toastr.info('Su sesión ha expirado, sera redireccionado.');
    localStorage.setItem('key', '');
    const redirect = '/authentication/login';
    this.router.navigate([redirect]);
  }

  private sessionStatus(): Observable<any> {
    const obj = {
      UserToken: this.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE() + 'Home/IsActiveSession', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public verifySession() {
    this.sessionStatus().subscribe(resp => {
      if (resp.Result) {
        return true;
      } else {
        this.redirectWeb();
      }
    });
  }



}



// WEBPACK FOOTER //
// ./src/app/global/global.service.ts